import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { setAuthToken, resetTokenGate } from "components/AxiosUtils";
import { getUserToken, removeUserTokenFromLocalStorage, setUserTokenInLocalStorage } from "./UserUtils";
import { getAuth0Config } from "./UtilsForAuth0";

  const auth0 = getAuth0Config();
export default function TokenBootstrap() {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    let cancelled = false;
    if (auth0.isActive) {
    (async () => {
    if (!isAuthenticated) {
        setAuthToken(null);     // unblocks waiters (they proceed without auth)
        resetTokenGate();       // future requests will wait for next login’s token
        return;
      }
      try {
      const token = await getAccessTokenSilently({
        authorizationParams: { 
      audience: auth0.audience,
      scope: "openid profile email read:current_user read:messages"},
        detailedResponse: false, // returns a string on 0.x usage too
      });
      if(token){
        setUserTokenInLocalStorage();
      }
      if (!cancelled) setAuthToken(token);
      } catch (e) {
        // Couldn’t get token; proceed without it.
        removeUserTokenFromLocalStorage(); 
        if (!cancelled) setAuthToken(null);
      }
    })();
  }
  else {        
        const token = getUserToken();         
        if (token) {
             setAuthToken(token);
        } else {
             setAuthToken(null);
             ////resetTokenGate();
        }
    }
    return () => { cancelled = true; };
  }, [isAuthenticated, getAccessTokenSilently]);

  return null;
}
